import { isEmpty } from "lodash";
import { LOCAL_PAYMENTS_URL } from "./const";

export function getPaymentsUrl() {
  const REACT_ENV = import.meta.env.VITE_HOST_ENV;
  const PAYMENTS_URL = !!import.meta.env.VITE_PAYMENTS_URL && import.meta.env.VITE_PAYMENTS_URL !== "" ? import.meta.env.VITE_PAYMENTS_URL : LOCAL_PAYMENTS_URL;
  if (!isEmpty(REACT_ENV)) {
    return PAYMENTS_URL;
  } else {
    return LOCAL_PAYMENTS_URL;
  }
}
